<template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-12
        SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .form-horizontal
            .form-group
              label.col-sm-4.control-label First Index
              .col-sm-8
                input.form-control(type="number" v-model.number="firstIndex" placeholder="First Index")

            .form-group
              label.col-sm-4.control-label Last Index
              .col-sm-8
                input.form-control(type="number" v-model.number="lastIndex" placeholder="Last Index")

            .form-group
              label.col-sm-4.control-label Description
              .col-sm-8
                input.form-control(v-model="description" placeholder="Roll Description")
</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    saving: false,
    firstIndex: null,
    lastIndex: null,
    description: null
  }),
  methods: {
    save() {
      this.saving = true
      const req = {
        firstCodeIndex: this.firstIndex,
        lastCodeIndex: this.lastIndex,
        description: this.description,
        orderId: this.orderId
      }
      Core.createRoll(req)
        .then(() => {
          miniToastr.success('Roll created')
          this.$router.push({ name: 'rolls', params: { id: this.orderId } })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    orderId() {
      return parseInt(this.$route.params.id, 10)
    },
    isValid() {
      return this.description
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/roll/RollCreate.vue